import NotificationsDasboardMobile from './component'

export default NotificationsDasboardMobile
